<!-- @format -->

<div class="row">
  <div class="col">
    <h3>{{ "FILE_UPLOAD.FILE_TITLE" | translate }}</h3>
  </div>
  <div class="col-md-auto button-holder">
    <sis-button (clicked)="editAttachments()" [size]="'sm'">{{ "BUTTON.EDIT" | translate }}</sis-button>
  </div>
</div>
@if (
  (!initialAttachments || initialAttachments.length === 0) &&
  (!externalAttainedStudyAttachments || externalAttainedStudyAttachments.length === 0)
) {
  <p class="guidance">{{ "FILE_UPLOAD.ZERO_FILES" | translate }} </p>
}
<sis-emrex-attachments [externalAttainedStudyAttachments]="externalAttainedStudyAttachments"></sis-emrex-attachments>
@for (attachment of initialAttachments; track attachment) {
  <div class="object file-preview">
    @if (attachment.localId) {
      <a [href]="attachment.preSignedGetUrl" target="_blank" class="file-name" data-cy="attachment">
        {{ attachment.name }} ({{ readableFileSizeString(attachment.file.size) }})
        <span class="visually-hidden">{{ "ARIA_LABEL.OPENS_TO_A_NEW_TAB" | translate }}</span>
      </a>
    }
    @if (!attachment.localId) {
      <span class="file-name">{{ attachment.file.name }} ({{ readableFileSizeString(attachment.file.size) }})</span>
    }
    <p>{{ attachment.explanation }}</p>
  </div>
}
